import React from 'react';
import { withRouter } from "react-router-dom";
import { translate } from "react-translate";
import Block from './block/block';
import Navbar from './navbar/navbar';
import Cover from './cover/cover';
import Footer from './footer/footer';
import President from './congress/president/president';
import About from './congress/about/about';
import Speakers from './congress/speakers/speakers';
import Schedule from './congress/schedule/schedule';
import Hotels from './congress/hotels/hotels';
import Partners from './congress/partners/partners';

import speaker from '../images/speaker.jpg';
import delegate from '../images/delegate.jpg';
import tbilisi from '../images/tbilisi1.jpg';
import kakheti from '../images/kakheti.jpg';
import sponsor from '../images/sponsor.png';

class CongressPage extends React.Component {

  render() {
    return (
      <div className="page congress">
        <Navbar commonProps={this.props.commonProps} congressNavigation={true} />
        <Cover commonProps={this.props.commonProps} />
        <div id="president" style={{ position: 'relative', top: '-100px', height: 0 }}>&nbsp;</div>
        <President commonProps={this.props.commonProps} />
        <About commonProps={this.props.commonProps} />
        <div id="speakers" style={{ position: 'relative', top: '-150px', height: 0 }}>&nbsp;</div>
        <Speakers commonProps={this.props.commonProps} />
        <div id="schedule" style={{ position: 'relative', top: '-150px', height: 0 }}>&nbsp;</div>
        <Schedule commonProps={this.props.commonProps} />
        <Hotels commonProps={this.props.commonProps} />
        <Partners commonProps={this.props.commonProps} />
        <Block whiteBG={true} button="/tbilisi" buttonText={this.props.t('readMore')} image={tbilisi} imageAlign="left" title={this.props.t('tbilisi_title')} body={this.props.t('tbilisi_body')} />
        <Block notice={this.props.t('registration_completed')} image={kakheti} imageAlign="right" title={this.props.t('excursion_title')} body={this.props.t('excursion_body')} />
        <div id="sponsor" style={{ position: 'relative', top: '-100px', height: 0 }}>&nbsp;</div>        
        <Block notice={this.props.t('registration_completed')} whiteBG={true} image={sponsor} imageAlign="left" title={this.props.t('sponsors_title')} body={this.props.t('sponsors_body')} />        
        <div id="speaker" style={{ position: 'relative', top: '-100px', height: 0 }}>&nbsp;</div>
        <Block notice={this.props.t('registration_completed')} image={speaker} imageAlign="right" title={this.props.t('speaker')} body={this.props.t('speaker_body')} />
        <div id="delegate" style={{ position: 'relative', top: '-100px', height: 0 }}>&nbsp;</div>         
        <Block notice={this.props.t('registration_completed')} whiteBG={true} image={delegate} imageAlign="left" title={this.props.t('delegate')} body={this.props.t('delegate_body')} />
        <Footer />
      </div>
    );
  }

}

export default translate('CongressPage')(withRouter(CongressPage));
